import React, { useState } from "react";
import { connect } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";
import { ReactComponent as Cross } from "../../assets/icons/Cross.svg";
import { ReactComponent as Logo } from "../../assets/icons/Group 50.svg";
import { ReactComponent as Menu } from "../../assets/icons/Menu.svg";
import { loginPage } from "../../Redux/Actions/Authentication";
export const headerLinksTexts = [
  { text: "پروفایل", path: "/profile", isPrivate: true },
  { text: "سوابق", path: "/history", isPrivate: true },
  { text: "در انتظار", path: "/waiting", isPrivate: true },
  { text: "مدیریت مصرف", path: "/usage", isPrivate: true },
  {
    text: "قبض موبایل ",
    path: `/Payment/Mobile`,
    companyId: 4,
    isPrivate: false
  },
  {
    text: "قبض تلفن ",
    path: `/Payment/Telephone`,
    companyId: 5,
    isPrivate: false
  },
  {
    text: "قبض آب ",
    path: `/Payment/Water`,
    companyId: 1,
    isPrivate: false
  },
  {
    text: "قبض گاز ",
    path: `/Payment/Gas`,
    companyId: 2,
    isPrivate: false
  },
  {
    text: "قبض برق ",
    path: `/Payment/Electricity`,
    companyId: 3,
    isPrivate: false
  },
  { text: "صفحه اصلی", path: "/", isPrivate: false }
];

const images = {
  headerBigScreen: require("../../assets/images/Group-150.jpg"),
  menuImage: require("../../assets/images/Path 1121.png"),
  headerMobile: require("../../assets/images/Group 157.jpg")
};

const texts = {
  descHeader: "مدیریت هوشمند قبوض شرکت های خدماتی",
  desc:
    "کنتور یک برنامه و سامانه بسیار کاربردی ، آسان و رایگان است و از میزان مصرف قبض ها جداگانه و یا تجمیعی گزارش گیری می کند."
};

export const HeaderLink = ({ selected, text, history, path, companyId }) => {
  return (
    <div
      onClick={() =>
        history.push({
          pathname: path
        })
      }
    >
      <div className={selected ? "headertextSelected" : null}>{text}</div>
      <div
        className={selected ? "headerLinkSelected" : "headerLinkNotSelected"}
      ></div>
    </div>
  );
};
const Header = ({ ...props }) => {
  const { isLogin, loginOpen } = props;
  const headerData = isLogin
    ? headerLinksTexts
    : headerLinksTexts.filter(i => !i.isPrivate);
  const history = useHistory();
  const [menuOpen, setMenuOpen] = useState(false);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const ImageSource =
    !isTabletOrMobile || !isPortrait
      ? images.headerBigScreen
      : images.headerMobile;
  return (
    <div className="header" id="mainHeader">
      <img src={ImageSource} alt={""} />
      {isTabletOrMobile && (
        <>
          <div className="mobileIcons">
            <Logo />
            {!menuOpen ? (
              <Menu onClick={() => setMenuOpen(!menuOpen)} />
            ) : (
              <Cross onClick={() => setMenuOpen(!menuOpen)} />
            )}
          </div>
          {menuOpen && (
            <div className="headerMenu" onClick={() => setMenuOpen(false)}>
              <img src={images.menuImage} alt={""} />
              <div>
                {!isLogin && (
                  <div onClick={loginOpen}>
                    <div>ورود</div>
                  </div>
                )}
                {headerData.map((i, index) => (
                  <HeaderLink
                    text={i.text}
                    companyId={i.companyId}
                    selected={false}
                    history={history}
                    path={i.path}
                    key={`#header${index}`}
                  />
                ))}
              </div>
            </div>
          )}
        </>
      )}
      {!isTabletOrMobile && (
        <div className="headerLinksDiv">
          {!isLogin && (
            <div className="signInBtn" onClick={loginOpen}>
              ورود/ثبت نام
            </div>
          )}
          <div className="headerLinks">
            {headerData.map((i, index) => {
              return (
                <HeaderLink
                  text={i.text}
                  history={history}
                  companyId={i.companyId}
                  path={i.path}
                  selected={i.path && history.location.pathname === i.path}
                  key={`#header${index}`}
                />
              );
            })}
            <Logo />
          </div>
        </div>
      )}
      <div className="headerDescription">
        <span>{texts.descHeader}</span>
        <span>{texts.desc}</span>
        <div
          className="moreDescBtn"
          onClick={() =>
            document.getElementById("companiesDiv") &&
            window.scrollTo({
              top: document.getElementById("companiesDiv").offsetTop,
              behavior: "smooth"
            })
          }
        >
          پرداخت
        </div>
      </div>
    </div>
  );
};
const mapDispatchToProps = dispatch => ({
  loginOpen: () => dispatch(loginPage(true))
});
export default connect(null, mapDispatchToProps)(Header);
